import { render, staticRenderFns } from "./AddressInputs.vue?vue&type=template&id=39edab68&scoped=true"
import script from "./AddressInputs.vue?vue&type=script&lang=js"
export * from "./AddressInputs.vue?vue&type=script&lang=js"
import style0 from "./AddressInputs.vue?vue&type=style&index=0&id=39edab68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39edab68",
  null
  
)

export default component.exports